function trackAddonsEvent({ element, elementValue = null, interaction }) {
  App.track.event('room_page_interaction', {
    section: 'add_ons',
    element,
    element_value: elementValue,
    interaction,
  });
}

export const initAddons = () => {
  const section = document.querySelector('.js-room-addons');
  if (!section) return;

  const rows = document.querySelectorAll('.js-room-addon-row');

  const sectionObserver = new IntersectionObserver((entries) => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    trackAddonsEvent({ element: 'add_ons', elementValue: rows.length, interaction: 'visible' });
    sectionObserver.disconnect();
  }, { threshold: 0.2 });
  sectionObserver.observe(section);

  const rowObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      trackAddonsEvent({
        element: 'add_on',
        elementValue: entry.target.dataset.name ?? null,
        interaction: 'visible',
      });
      rowObserver.unobserve(entry.target);
    });
  }, { threshold: 0.2 });

  rows.forEach((row) => {
    rowObserver.observe(row);

    row.addEventListener('click', () => {
      trackAddonsEvent({
        element: 'add_on',
        elementValue: row.dataset.name ?? null,
        interaction: 'click',
      });

      const addOnId = Number(row.dataset.id);
      if (!Number.isFinite(addOnId)) return;
      window.triggerShowRoomAddOnModal?.(addOnId);
    });
  });

  const showMoreBtn = document.querySelector('.js-room-addons-show-more');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', () => {
      trackAddonsEvent({ element: 'show_more_button', interaction: 'click' });

      document.querySelectorAll('.js-room-addon-row--hidden').forEach((row) => {
        row.classList.remove('none', 'js-room-addon-row--hidden');
      });
      showMoreBtn.remove();
    });
  }
};
